module.exports = __webpack_public_path__ + "img/home-flats.d6c9da4e.jpg";